const authPaths = {
  basePath: "login",
};

export default authPaths;
